/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Col_CurrentInputs */

const vi_customer_debt_col_current = /** @type {(inputs: Customer_Debt_Col_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nợ hiện tại`)
};

/**

* @param {Customer_Debt_Col_CurrentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_col_current = /** @type {((inputs?: Customer_Debt_Col_CurrentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Col_CurrentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_col_current(inputs)
});